import { useNavigate, useLocation } from "react-router-dom";
import { Bot } from "lucide-react";

/**
 * Tiny floating "Oracle (IPO.GPT)" robot button.
 * Rendered inside ProtectedRoute so it appears on every authenticated page.
 * Hidden on the Oracle page itself.
 */
const OracleFloatingButton = () => {
  const navigate = useNavigate();
  const location = useLocation();
  if (location.pathname.startsWith("/oracle")) return null;
  // On the New User Landing the "Ask Oracle" action lives in the header instead.
  if (location.pathname.startsWith("/home")) return null;
  // On the Registered Advisor page the "Ask Oracle" action lives in the header.
  if (location.pathname.startsWith("/registered-advisor")) return null;
  // On the IPO Navigator the "Ask Oracle" action lives in the top nav.
  if (location.pathname.startsWith("/ipo-navigator")) return null;
  // On the IPO Role Select page the "Ask Oracle" action lives in the top bar.
  if (location.pathname.startsWith("/ipo-role-select")) return null;
  // On the CA Firm Dashboard the "Ask Oracle" action lives in the top bar.
  if (location.pathname.startsWith("/ca-firm-dashboard")) return null;
  // On the Advisor Onboarding page the "Ask Oracle" action lives in the top bar.
  if (location.pathname.startsWith("/advisor-onboarding")) return null;
  // On the Advisor Marketplace the "Ask Oracle" action lives in the top bar.
  if (location.pathname.startsWith("/advisor-marketplace")) return null;
  // On a dedicated Advisor Profile page the floating buttons are removed by request.
  if (location.pathname.startsWith("/advisor/")) return null;
  // On the DRHP Workspace the "Ask Oracle" action lives in the top bar.
  if (location.pathname.startsWith("/drhp-workspace")) return null;
  // On the IPO Cost Estimator the "Ask Oracle" action lives in the top bar.
  if (location.pathname.startsWith("/ipo-cost-estimator")) return null;
  // On the Published Projects page the "Ask Oracle" button is removed by request.
  if (location.pathname.startsWith("/published-projects")) return null;

  return (
    <button
      onClick={() => navigate("/oracle")}
      className="fixed top-[168px] right-[44px] z-40 group flex items-center gap-2.5 pl-3.5 pr-5 py-2.5 rounded-full bg-white border border-gray-200 shadow-md hover:shadow-lg hover:border-blue-300 hover:bg-blue-50 transition-all"
      data-testid="oracle-floating-btn"
      title="Ask Oracle (IPO.GPT)"
    >
      <span className="relative">
        <Bot className="w-5 h-5 text-[#1DA1F2] group-hover:text-blue-700 transition-colors" strokeWidth={2.2} />
        <span className="absolute -top-0.5 -right-0.5 w-2 h-2 rounded-full bg-emerald-500 ring-2 ring-white" />
      </span>
      <span className="text-[14px] font-semibold text-gray-700 group-hover:text-blue-800 hidden sm:inline">
        Ask Oracle {"{IPO.GPT}"}
      </span>
    </button>
  );
};

export default OracleFloatingButton;
